import { Injectable } from '@angular/core';
import { filter, map, Observable } from 'rxjs';
import { Params } from '@angular/router';
import { IPaginatedResponse } from '../typing/response.interface';
import { ILabelValue } from '../ui-lib/common-dropdawn/typing/label-value.interface';
import { ProjectService } from './project.service';
import { IProject } from '../typing/project.interface';

@Injectable({
    providedIn: 'root'
})
export class ProjectSelectorService {

    constructor(private projectService: ProjectService) {
    }

    getList(query: Params): Observable<IPaginatedResponse<ILabelValue>> {
        return this.projectService.getList(query).pipe(map(response => this.transformData(response)));
    }

    transformData(paginatedResponse: IPaginatedResponse<IProject>): IPaginatedResponse<ILabelValue> {
        const transformedData = paginatedResponse.data.map(project => ({
            label: project.name,
            value: project.id,
            tooltip: this.getTooltip(project),
        }));

        return {
            ...paginatedResponse,
            data: transformedData,
        } as IPaginatedResponse<ILabelValue>;
    }

    getOptionsByValue(optionValue: number | string): Observable<ILabelValue> {
        return this.projectService.getProject(Number(optionValue)).pipe(
            filter(project => !!project),
            map(project => ({
                label: project.name as string,
                value: project.id as number,
                tooltip: '---',
            })),
        );
    }

    getTooltip(value: IProject): string {
        return (value.name ? value.name : '') + (value.id ? '; id:' + value.id : '') ;
    }

}
